/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  MESSAGE_MANDATORY: {
    id: 'app.MESSAGE_MANDATORY',
    defaultMessage: 'MESSAGE_MANDATORY'
  },
  EMPTY_MESSAGE: {
    id: 'app.EMPTY_MESSAGE',
    defaultMessage: 'EMPTY_MESSAGE'
  },
  CANCEL_LABEL: {
    id: 'app.CANCEL_LABEL',
    defaultMessage: 'CANCEL_LABEL'    
  },
  OK_LABEL: {
    id: 'app.OK_LABEL',
    defaultMessage: 'OK_LABEL'    
  }
})



// WEBPACK FOOTER //
// ./src/generic/form/constants.js